import { Select, Typography, Table } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { serverUrl } from "../../../../nestserver";
import { selectUser } from "../../../../redux/slices/auth.slice";
import LiveBusMap from "../../../admin/pages/Live tracking/LiveBusMap";

const { Option } = Select;
const { Title } = Typography;

const StudentLiveTracking = () => {
  const [routeId, setRouteId] = useState();
  const [routeData, setRouteData] = useState(null);
  const user = useSelector(selectUser);

  async function fetchRoute() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const routes = useQuery(["routes/v2"], () => fetchRoute());

  useEffect(() => {
    if (routes?.isSuccess && user?.route_id) {
      const userRouteId = user?.route_id?._id || user?.route_id;
      const filteredRoutes = routes?.data?.result?.data?.filter(
        (data) => data?._id === userRouteId,
      );
      if (filteredRoutes?.length === 1) {
        setRouteId(filteredRoutes[0]._id);
      }
    }
  }, [routes, user]);

  useEffect(() => {
    if (routeId) {
      const selectedRoute = routes?.data?.result?.data?.find(
        (data) => data?._id === routeId,
      );
      setRouteData(selectedRoute);
    }
  }, [routeId, routes]);

  async function fetchIssues(id) {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2/${id}/alerts`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }

  const issueDetails = useQuery(
    ["routes/v2/alerts", routeId],
    () => routeId && fetchIssues(routeId),
    {
      enabled: !!routeId,
    },
  );
  const columnsLog = [
    {
      title: "Date",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center"
        >
          {record?.createdAt
            ? moment(record?.createdAt).format("DD/MM/YYYY")
            : "-"}
        </div>
      ),
    },
    {
      title: "Alert",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => {
        return (
          <div
            key={record}
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {record?.alert}
          </div>
        );
      },
    },
  ];

  return (
    <div className="pt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full "
      >
        <div className="text-2xl text-orange-500 font-semibold mb-6">
          Live Tracking
        </div>
        <div className="flex gap-10px mb-6 items-center">
          <h6 className=" font-semibold text-base">Route: &nbsp;</h6>
          <Select
            showSearch
            showArrow
            placeholder="Select Route"
            className=" bg-gray-300 capitalize"
            style={{
              border: "6px",
              backgroundColor: "#EBEBEB",
              width: "30%",
            }}
            onChange={(val) => setRouteId(val)}
            value={routeId}
          >
            {routes?.isSuccess &&
              routes?.data?.result?.data
                ?.filter((data) => {
                  const userRouteId = user?.route_id?._id || user?.route_id;
                  return data?._id === userRouteId;
                })
                ?.map((data) => {
                  return (
                    <Option key={data._id} value={data._id}>
                      {data?.name}
                    </Option>
                  );
                })}
          </Select>
        </div>

        <div className="pt-4">
          <LiveBusMap
            routeData={routeData}
            routeId={routeId}
            routes={routes?.data?.result?.data || []}
          />
        </div>

        <Title level={5} className="pt-8">
          Alert Log
        </Title>
        <div className="py-5">
          <Table
            rowKey="_id"
            columns={columnsLog}
            dataSource={
              issueDetails?.isSuccess &&
              issueDetails?.data?.result?.data?.length > 0 &&
              issueDetails?.data?.result?.data
                ? issueDetails?.data?.result?.data
                : []
            }
            pagination={true}
            loading={issueDetails?.isLoading}
            locale={{ emptyText: "No alerts for this route" }}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentLiveTracking;
